export var LayerState;
(function (LayerState) {
    LayerState[LayerState["Active"] = 0] = "Active";
    LayerState[LayerState["TransitionExit"] = 1] = "TransitionExit";
})(LayerState || (LayerState = {}));
export var APIMessageType;
(function (APIMessageType) {
    APIMessageType[APIMessageType["PushLayer"] = 0] = "PushLayer";
    APIMessageType[APIMessageType["UpdateLayer"] = 1] = "UpdateLayer";
    APIMessageType[APIMessageType["TransitionExitLayer"] = 2] = "TransitionExitLayer";
    APIMessageType[APIMessageType["RemoveLayer"] = 3] = "RemoveLayer";
})(APIMessageType || (APIMessageType = {}));
